(function () {
    const TERMS_LABEL_HTML = 'I agree to the <a href="/pages/terms-and-conditions" target="_blank" rel="noopener">terms and conditions</a>';
    const ERROR_HTML = 'Please accept the terms and conditions to proceed.';
  
    const FOOTER_SELECTOR = '.atc-banner--cart-footer';
    const CHECKOUT_BUTTON_SELECTOR = '.atc-button--checkout, button[name="checkout"]';
  
    function createTermsBlock() {
      const wrap = document.createElement('div');
      wrap.className = 'js-terms-inline terms-inline';
      wrap.innerHTML = `
        <div class="terms-inline__wrapper">
          <input class="terms-inline__input" type="checkbox" />
          <label class="terms-inline__label">${TERMS_LABEL_HTML}</label>
        </div>
        <div class="terms-inline__error" hidden>${ERROR_HTML}</div>
      `;
      return wrap;
    }
  
    // Place a terms block directly ABOVE the footer (if not already there).
    function ensureTermsAboveFooter(footerEl) {
      if (!footerEl) return;
      const prev = footerEl.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('js-terms-inline')) return;
      const termsEl = createTermsBlock();
      footerEl.parentNode.insertBefore(termsEl, footerEl);
      updateVisualStateForFooter(footerEl); // initialise disabled state
    }
  
    // Find the terms block associated with a footer (assumed just above it).
    function getTermsForFooter(footerEl) {
      const prev = footerEl?.previousElementSibling;
      return (prev && prev.classList?.contains('js-terms-inline')) ? prev : null;
    }
  
    // Given a target (button/form), find its nearest footer, then that footer’s terms.
    function getTermsForTarget(target) {
      const footer = target.closest(FOOTER_SELECTOR);
      return getTermsForFooter(footer);
    }
  
    function updateVisualStateForFooter(footerEl) {
      const terms = getTermsForFooter(footerEl);
      if (!terms) return;
      const checkbox = terms.querySelector('.terms-inline__input');
      const errorEl = terms.querySelector('.terms-inline__error');
      const btn = footerEl.querySelector(CHECKOUT_BUTTON_SELECTOR);
      if (!btn || !checkbox) return;
  
      const checked = checkbox.checked;
      errorEl.hidden = true;
  
      if (checked) {
        btn.classList.add('terms-enabled');
        btn.classList.remove('terms-disabled');
        btn.removeAttribute('aria-disabled');
      } else {
        btn.classList.add('terms-disabled');
        btn.classList.remove('terms-enabled');
        btn.setAttribute('aria-disabled', 'true');
      }
    }
  
    // Initialise (or reinitialise) all current footers
    function ensureAll() {
      document.querySelectorAll(FOOTER_SELECTOR).forEach((footer) => {
        ensureTermsAboveFooter(footer);
      });
    }
  
    // Delegated: block clicks on checkout buttons if terms unchecked
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(CHECKOUT_BUTTON_SELECTOR);
      if (!btn) return;
  
      const terms = getTermsForTarget(btn);
      if (!terms) return; // if no terms block, do nothing
  
      const checkbox = terms.querySelector('.terms-inline__input');
      const errorEl = terms.querySelector('.terms-inline__error');
      if (!checkbox?.checked) {
        e.preventDefault();
        e.stopPropagation();
        errorEl.hidden = false;
        checkbox?.focus();
      }
    }, true); // capture = true to get ahead of other handlers
  
    // Delegated: block form submits to /cart -> checkout if terms unchecked
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form || !(form.action || '').includes('/cart')) return;
  
      const terms = getTermsForTarget(form);
      if (!terms) return;
  
      const checkbox = terms.querySelector('.terms-inline__input');
      const errorEl = terms.querySelector('.terms-inline__error');
      if (!checkbox?.checked) {
        e.preventDefault();
        e.stopPropagation();
        errorEl.hidden = false;
        checkbox?.focus();
      }
    }, true);
  
    // When a checkbox toggles, update its paired footer button state
    document.addEventListener('change', (e) => {
      if (!e.target.classList?.contains('terms-inline__input')) return;
      // find the footer this terms belongs to (nextElementSibling)
      const terms = e.target.closest('.js-terms-inline');
      const footer = terms?.nextElementSibling?.matches?.(FOOTER_SELECTOR) ? terms.nextElementSibling : null;
      if (footer) updateVisualStateForFooter(footer);
    });
  
    // Run on load and whenever your app updates the cart
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ensureAll);
    } else {
      ensureAll();
    }
    window.addEventListener('cartcount:update', () => {
      // allow DOM to settle if another script injects asynchronously
      setTimeout(ensureAll, 0);
    });
  
    // Safety net: if the theme clones/injects footers, observe and seed terms + state
    const mo = new MutationObserver((mutations) => {
      let touched = false;
      for (const m of mutations) {
        m.addedNodes && m.addedNodes.forEach((n) => {
          if (!(n instanceof HTMLElement)) return;
          // Footers themselves or containers containing them
          if (n.matches?.(FOOTER_SELECTOR) || n.querySelector?.(FOOTER_SELECTOR)) {
            touched = true;
          }
        });
      }
      if (touched) ensureAll();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();